import { Link } from 'react-router-dom';
import Card from '../../../components/base/Card';
import useScrollReveal from '../../../hooks/useScrollReveal';

// KF-specific highlights only — the universal conduct (respect, fair play,
// clean chat) lives on the hub and is linked below, not repeated here.
const ruleHighlights = [
  {
    icon: 'ri-bar-chart-box-line',
    title: 'Perk Integrity',
    text: 'Boosting perks through map or server exploits gets your perk levels reset to zero. Earn your levels legit.',
  },
  {
    icon: 'ri-team-line',
    title: 'Co-op First',
    text: 'No team-damage, team-killing, or griefing teammates by blocking paths or welding them in. Watch each other’s backs.',
  },
  {
    icon: 'ri-user-settings-line',
    title: 'Fair Lobbies',
    text: 'No votekick abuse, and keep nicknames clean and within the allowed length and character format.',
  },
];

export default function RulesSection() {
  const sectionRef = useScrollReveal();

  return (
    <section id="rules" ref={sectionRef} className="py-20 bg-gradient-to-b from-black/80 to-gray-900/80">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 scroll-reveal">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 font-orbitron horror-heading">
            Server <span className="text-red-500">Rules</span>
          </h2>
          <div className="w-24 h-1 bg-red-600 mx-auto mb-6"></div>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Play fair, respect others, and keep the server fun for everyone. Breaking these rules leads to mutes, kicks, or bans.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto mb-10">
          {ruleHighlights.map((item, index) => (
            <div key={item.title} className="scroll-reveal" style={{ animationDelay: `${(index + 1) * 0.1}s` }}>
              <Card variant="dark" className="h-full hover:scale-[1.02] transition-transform duration-300">
                <div className="w-12 h-12 rounded-lg bg-red-600/20 border border-red-800/40 flex items-center justify-center mb-5">
                  <i className={`${item.icon} text-2xl text-red-400`}></i>
                </div>
                <h3 className="text-xl font-bold text-white font-orbitron mb-3">{item.title}</h3>
                <p className="text-gray-300 leading-relaxed">{item.text}</p>
              </Card>
            </div>
          ))}
        </div>

        <div className="text-center scroll-reveal space-y-4" style={{ animationDelay: '0.4s' }}>
          <div>
            <Link
              to="/rules"
              className="inline-flex items-center justify-center gap-2 rounded-lg bg-red-600 px-8 py-3 font-bold text-white transition-all duration-200 hover:bg-red-700 hover:shadow-red-glow"
            >
              Read Full Rules
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <p className="text-gray-400 text-sm">
            These are KF-specific rules.{' '}
            <a
              href="https://uliunai.com/conduct"
              target="_blank"
              rel="noopener noreferrer"
              className="text-red-400 hover:text-red-300 transition-colors font-semibold"
            >
              Community-wide conduct
            </a>{' '}
            applies across all Uliunai games.
          </p>
        </div>
      </div>
    </section>
  );
}
